import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrganizationUserDto } from 'src/app/data-transfer/entities/organization-user-dto';
import { DialogActions } from 'src/app/model/dictionary';
import { AdminDialogResult } from '../admin-dialog-result';
import { getUserDisplayName } from '../organization-user.util';

export interface AdminLeadAdminTransferDialogData {
  currentLeadAdmin: OrganizationUserDto;
  candidates: OrganizationUserDto[];
}

export type AdminLeadAdminTransferDialogResult = AdminDialogResult<{ newLeadAdmin: OrganizationUserDto }>;

@Component({
  selector: 'app-admin-lead-admin-transfer-dialog',
  templateUrl: './admin-lead-admin-transfer-dialog.component.html',
  styleUrls: ['./admin-lead-admin-transfer-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminLeadAdminTransferDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<AdminLeadAdminTransferDialogComponent, AdminLeadAdminTransferDialogResult>>(MatDialogRef);
  protected readonly data = inject<AdminLeadAdminTransferDialogData>(MAT_DIALOG_DATA);
  protected readonly currentLeadAdminName = getUserDisplayName(this.data.currentLeadAdmin);

  protected readonly searchControl = new FormControl<string>('', { nonNullable: true });
  protected readonly selectedUser = signal<OrganizationUserDto | undefined>(undefined);

  private readonly searchTerm = toSignal(this.searchControl.valueChanges, { initialValue: this.searchControl.value });
  protected readonly filteredCandidates = computed(() => {
    const term = this.searchTerm().trim().toLowerCase();
    if (!term) return this.data.candidates;
    return this.data.candidates.filter(user => getUserDisplayName(user).toLowerCase().includes(term) || user.email.toLowerCase().includes(term));
  });

  protected selectUser(user: OrganizationUserDto): void {
    this.selectedUser.set(user);
  }

  protected confirm(): void {
    const newLeadAdmin = this.selectedUser();
    if (!newLeadAdmin) return;

    this.dialogRef.close({ event: DialogActions.CONFIRM, data: { newLeadAdmin } });
  }

  protected closeDialog(): void {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
